import apiClient from '../../api/apiClient';

export const fetchCreditBalance = (organization) =>
  apiClient.get('/api/credits/balance/', { params: organization ? { organization } : {} }).then((r) => r.data);

export const fetchCreditTransactions = (page = 1, organization = null) =>
  apiClient.get('/api/credits/transactions/', { params: { page, ...(organization ? { organization } : {}) } }).then((r) => r.data);

export const redeemCreditVoucher = (code, organization = null) =>
  apiClient.post('/api/credits/redeem/', { code, ...(organization ? { organization } : {}) }).then((r) => r.data);

export const previewAnalysisCost = (batchId, pipelines, sampleIds) =>
  apiClient.post('/api/credits/analysis-cost-preview/', {
    batch_id: batchId,
    pipelines,
    ...(sampleIds?.length ? { sample_ids: sampleIds } : {}),
  }).then((r) => r.data);
